const jishsaLocalLogic = {
	login : async (email,password)=>{
		const query = `mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
			customerAccessTokenCreate(input: $input){
				customerAccessToken {
					accessToken
					expiresAt
				}
				customerUserErrors {
					code
					field
					message
				}
			}
		}`;
		const input = {
			"email": email,
			"password": password
		};
		const ret = await jishsaLocalLogic.processFrontstoreAPI("customerAccessTokenCreate",query,input);
		if(!ret || !ret.customerAccessTokenCreate || !ret.customerAccessTokenCreate.customerAccessToken)return false;

		return ret.customerAccessTokenCreate.customerAccessToken;
	},
	checkLogin : async (email,password)=>{
		const customerAccessToken = await jishsaLocalLogic.login(email,password);
		if(!customerAccessToken){
			localStorage.removeItem("LoginToken");
			return false;
		}
		
		localStorage.setItem("LoginToken",JSON.stringify(customerAccessToken));
		return true;
	},
	isLogined : ()=>{
		const customerAccessToken = localStorage.getItem("LoginToken");
		if(!customerAccessToken)return false;
		return true;
	},
	processFrontstoreAPI : async (operationName,query,input)=>{
		const response = await fetch(window.jishaConfig.SHOPIFY_STORE_FRONT_API_URL, {  
		method: 'POST',
		mode: 'cors',
		cache: 'no-cache',
		credentials: 'same-origin',
		headers: {
			accept: "*/*",
			"Content-Type": "application/json",
			'X-Shopify-Storefront-Access-Token': window.jishaConfig.SHOPIFY_STORE_FRONT_API_TOKEN
		},
		body: JSON.stringify({operationName,query,variables:{ input }})
		});
		const json = await response.json();
		if(!json || !json.data)return false;
		return json.data;

	}
}
